import * as React from 'react'

export const ArrowIcon: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
      <g id="Rounded Arrow" data-name="Rounded Arrow">
        <rect id="Box" width="20" height="20" transform="translate(0.294)" fill="none" />
        <path
          id="Path_2041"
          data-name="Path 2041"
          d="M587.453,7.138l-6.715,6.715a1.445,1.445,0,0,0,2.044,2.044l5.693-5.693,5.693,5.693a1.445,1.445,0,0,0,2.044-2.044L589.5,7.138A1.411,1.411,0,0,0,587.453,7.138Z"
          transform="translate(-578.745 -1.13)"
        />
      </g>
    </svg>
  )
}
